import { TFunction } from '@lichtblick/i18next';
import { GetWorkOrderFilesPayloadModel, TreeNode } from '@lichtblick/types';

export const transformToTreeNode = (data: GetWorkOrderFilesPayloadModel[], t: TFunction): TreeNode[] => {
  const map = new Map<number, TreeNode>();

  // Helper function to get or create a node in the map
  const getNode = (id: number, name: string, type: string): TreeNode => {
    if (!map.has(id)) {
      let currentName = name;

      if (!name) {
        currentName = data.find((d) => d.id === id)?.name ?? '';
      }

      map.set(id, { id, name: currentName, type, children: [] });
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return map.get(id)!;
  };

  // Process all folders and files
  for (const item of data) {
    // Create or get the folder node
    const folderNode = getNode(item.id, item.name === '<root>' ? t('pm:root') : item.name, 'folder');

    // If the folder has files, process them
    if (item.files) {
      for (const file of item.files) {
        if (file.fileName) {
          const fileNode: TreeNode = {
            id: file.id,
            name: file.fileName,
            type: 'file',
          };

          folderNode.children?.push(fileNode);
        }
      }
    }

    // If the item has a parentId, add it to its parent's children
    if (item.parentId) {
      const parentNode = getNode(item.parentId, '', 'folder');

      parentNode.children?.push(folderNode);
    }
  }

  // Filter out the root nodes (those without a parentId)
  const rootNodes: TreeNode[] = [];

  for (const node of map.values()) {
    if (!data.find((item) => item.id === node.id)?.parentId) {
      rootNodes.push(node);
    }
  }

  return rootNodes;
};

export const findFolderById = (nodes: TreeNode[], folderId: number): TreeNode | null => {
  for (const node of nodes) {
    if (node.id === folderId) {
      return node;
    }

    if (node.children && node.children.length > 0) {
      const foundChild = findFolderById(node.children, folderId);

      if (foundChild) {
        return foundChild;
      }
    }
  }

  return null;
};
